import React, { useState, useEffect } from 'react';

// Material
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';

// Hooks
import useNotify from '../../../../hooks/notify';
import useUser from '../../../../hooks/user/useUser';

// Components
import Modal from '../../../../components/modal/index';
import ModalSendEmail from '../../../../components/modal/sendEmail';
import { PrintModal, Spinner } from '@arredo/reactjs-ui';

import OrderService from '../../../../services/orderService';
import BranchService from '../../../../services/branchService';

const ChangeTicketPrintModal = ({ items, voucher, onClose, open, isSendMail = false, customerEmail }) => {
    const [loading, setLoading] = useState(false);
    const { Notify, variants } = useNotify();
    const { branch } = useUser();
    const [printerId, setPrinterId] = useState();
    const [changeTicket, setChangeTicket] = useState();
    const [showSendEmailModal, setShowSendEmailModal] = useState(false);
    const [copies, setCopies] = useState(1);
    const [printers, setPrinters] = useState([]);

    useEffect(() => {
        if (!branch?.id) return;
        BranchService.GetPrinters(branch.id)
            .then((res = []) => {
                const withOutFiscal = res.filter(printer => printer.isFiscal === false);
                setPrinters(withOutFiscal);
            })
            .catch(() => Notify("Error al intentar obtener impresoras", variants.ERROR));
    }, [branch?.id, Notify, variants.ERROR]);

    useEffect(() => {
       if(voucher?.id) {
        setLoading(true)
        OrderService
            .GetChangeTicket(voucher.id, [])
            .then(res => setChangeTicket(res))
            .catch(() => Notify("Error al intentar obtener factura", variants.ERROR))
            .finally(() => setLoading(false));
       }
    }, [voucher?.id]);
   
    const handlerOnAccept = async () => {
        setLoading(true);
        if (!isSendMail) {
            OrderService
                .GetChangeTicket(voucher.id, [])
                .then(res => setChangeTicket(res))
                .catch(() => Notify("Error al intentar obtener factura", variants.ERROR))
                .finally(() => setLoading(false));
        } else
            setShowSendEmailModal(true);
    }

    const handlePrint = async () => {
        setLoading(true);

         OrderService
             .PrintChangeTicket(voucher.id, printerId, [], copies)
             .then(() => Notify("Ticket de cambio impreso", variants.SUCCESS))
             .catch(() => Notify("Error al intentar imprimir ticket de cambio", variants.ERROR))
             .finally(() => {
                setLoading(false);
                onClose();
            });
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title='Ticket de cambio'
            contentProps={{ dividers: true }}
            customButtons={() =>
                <DialogActions>
                    <Button
                        onClick={ onClose } 
                        color="primary"
                    >
                        Cerrar
                    </Button>
                    {
                        !changeTicket &&
                        <Button 
                            onClick={ handlerOnAccept } 
                            color="primary" 
                            variant='outlined'
                            autoFocus
                        >
                            Aceptar
                        </Button>
                    }
                    {
                        !!changeTicket && !isSendMail &&
                        <Button
                            onClick={ handlePrint } 
                            color="primary"
                            variant='outlined'
                            autoFocus
                            disabled= { !printerId }
                        >
                            Imprimir
                        </Button>
                    }
                </DialogActions>
            }
        >
            {
                loading &&
                <Spinner lockScreen />
            }
            {
                !!changeTicket && !isSendMail &&
                <PrintModal
                    ticket={changeTicket}
                    loading={loading}
                    isTaxFree={false}
                    handleSwitchChange={() => {}}
                    printers={printers}
                    handleSelectPrinter={setPrinterId}
                    country={branch?.country}
                    printerSelected={printerId}
                    copies={copies}
                    onCopiesChange={setCopies}
                />
            }
            {
                showSendEmailModal &&
                <ModalSendEmail
                    title='Envio de mail'
                    open={showSendEmailModal}
                    onClose={onClose}
                    contentProps={{ dividers: true }}
                    onCancel={onClose}
                    email={customerEmail}
                    voucherId={voucher?.id}
                    changeItems={[]}
                    isChange
                />
            }
        </Modal>
    );
}

export default ChangeTicketPrintModal;